<template>
<div class="chapter">
<div class="inner_page">
<div id="d3ce853440f00-d1e241"><span id="pageiii">
<h1 class="book-title">COLD FLORIDA</h1>
<h2 class="book-subtitle"><em class="char-italic italic">A Foggy Moskowitz Mystery</em></h2>
<h2 class="book-author">Phillip DePoy</h2>
<p class="publisher-logo"><span class="image-centered" id="imgd1e954"><img alt="" src="OEBPS/images/9781780107394_epub_002.jpg"/></span></p></span></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781780107394_epub_tp.vue?65b2b04f